import { regularWhite } from '@ui-components/design-tokens';
import PlayText, { SIZE } from '@ui-components/typography/PlayText';
import ContinueWatching from '@utils/models/ContinueWatching';
import React from 'react';
import { A11yText, RemoveItemsButtonIcon, RemoveItemsButtonText } from './EditButtons.styles';

type Props = {
    markedAsDeleted: Array<ContinueWatching>;
    text: string;
    editModeActivated: boolean;
};

const EditButtons = ({ markedAsDeleted, text, editModeActivated }: Props): JSX.Element => {
    let accessibilityText = 'Du har inga markerade program.';

    if (markedAsDeleted && markedAsDeleted.length > 0) {
        accessibilityText = `Du har tagit bort ${markedAsDeleted.length} program från ${text}.`;
    }

    if (editModeActivated) {
        return (
            <PlayText fontColor={regularWhite} size={SIZE.MINI}>
                <RemoveItemsButtonIcon />
                <RemoveItemsButtonText data-rt="delete-programs-done-button">
                    Klar <A11yText>. {accessibilityText}</A11yText>
                </RemoveItemsButtonText>
            </PlayText>
        );
    }

    return (
        <PlayText fontColor={regularWhite} size={SIZE.MINI}>
            <RemoveItemsButtonText data-rt="delete-programs-button">Ta bort program</RemoveItemsButtonText>
            <A11yText> från {text}</A11yText>
        </PlayText>
    );
};

export default EditButtons;
